import AvsInBasket from '@/visa-application/models/AvsInBasket';

export enum IdentityType {
  ORDINARY_PASSPORT = 'ordinary_passport',
  DIPLOMATIC_PASSPORT = 'diplomatic_passport',
  SERVICE_PASSPORT = 'service_passport',
  OFFICIAL_PASSPORT = 'official_passport',
  SPECIAL_PASSPORT = 'special_passport',
  OTHER_PASSPORT = 'other'
}

export interface FormData {
  f_cai?: string;
  f_identity_type?: IdentityType;
  f_id: number;
  f_pers_surnames: string;
  f_pers_givennames: string;
  f_trav_purpose: string;
  f_pers_mobile_phone?: string;
  f_pass_num?: string;
  imageSrc?: string;
  travPurposeName?: string;
  f_status?: string;
  statusTranslation?: string;
  visaTypeTranslation?: string;
  fi_appointment_type?: string;
  fi_csl_appointment_type?: string;
  fi_passback_address?: string;
  f_xcopy_ug_type?: string;
  f_visa_type?: string;
  f_fee?: string;
  house_number?: string;
  street?: string;
  city?: string;
  postcode?: string;
  dropdownStatus?: boolean;
  fixedDropdownStatusAsTrue?: boolean;
  allowModificationOfCourierAddress?: boolean;
  f_pers_age?: number;
  f_pers_birth_date?: string;
}

export interface IFormStageStatus {
  f_id: number;
  stage: string;
  stage_number: number;
  status: string;
  st_when: string;
  st_who: number;
  f_xref_fg_id: number;
  f_is_anonymised: boolean;
  f_tech_deleted: boolean;
  f_xcopy_ug_type: string;
  f_xcopy_ug_xref_i_tag: string;
  variant: string;
  fg_process: string;
}

export interface AvsOfForm {
  f_id: number;
  f_pers_surnames?: string;
  f_pers_givennames?: string;
  avsList: AvsInBasket[];
}

export interface IFee {
  f_id: number;
  fee_type: string;
  amount: number;
  currency: string;
  name?: string;
  status?: string;
}

export interface TransactionData {
  t_id: number;
  expire?: string;
  transaction_id?: string;
  avs_num?: number;
  status?: string;
  status_code?: string;
  gateway?: string;
  items?: TransactionDataItems[];
}

export interface TransactionDataItems {
  f_id?: number;
  skus?: [];
}
